// Pages that don't require authentication and shouldn't show the command menu
const PUBLIC_PAGE_PATTERNS = [
  /^\/invoices\/(?!create)[^/]+\//, // /invoices/[id]/ but not /invoices/ or /invoices/create
  /^\/accounts\/[^/]+\/transactions\/inbound\//, // /accounts/[account]/transactions/inbound/[transaction]
  /^\/accounts\/[^/]+\/transactions\/(?!inbound)[^/]/, // /accounts/[account]/transactions/[transaction] (not inbound)
  /^\/invalid-link/,
  /^\/compliance\/accept-invitation/,
]

export const isPublicPage = (pathname: string): boolean =>
  PUBLIC_PAGE_PATTERNS.some((pattern) => pattern.test(pathname))
